import { render, staticRenderFns } from "./Tel.vue?vue&type=template&id=e012972e&scoped=true&"
import script from "./Tel.vue?vue&type=script&lang=js&"
export * from "./Tel.vue?vue&type=script&lang=js&"
import style0 from "./Tel.vue?vue&type=style&index=0&id=e012972e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e012972e",
  null
  
)

export default component.exports